export const extractCurrentQueries = key => {
  const data = sessionStorage.getItem(key);
  if (data) {
    return JSON.parse(data);
  }
  return {};
};

export const saveCurrentQueries = (data, key) => sessionStorage.setItem(key, JSON.stringify(data));
